// Contacts.jsx

import React, { useState, useEffect } from "react";
import {
  User,
  Mail,
  Phone,
  MessageSquareText,
  BadgeHelp,
  Eye,
  X,
  Calendar,
} from "lucide-react";

import axios from "axios";
import "../css/Contacts.css";

const Contacts = () => {

  const [contacts, setContacts] = useState([]);

  const [selectedContact, setSelectedContact] =
    useState(null);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {

    try {

      const res = await axios.get(
        "/api/contacts"
      );

      setContacts(res.data || []);

    } catch (error) {

      console.error(
        "Error fetching contacts:",
        error
      );
    }
  };

  return (
    <div className="contacts-page">

      {/* HEADER */}
      <div className="contacts-header">

        <div>
          <h1>Contact Forms</h1>
          <p>
            Manage all submitted contact forms
          </p>
        </div>

        <div className="contacts-count-card">
          Total Contacts: {contacts.length}
        </div>

      </div>

      {/* TABLE */}
      <div className="contacts-table-wrapper">

        <table className="contacts-table">

          <thead>

            <tr>
              <th>ID</th>
              <th>Customer</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Enquiry</th>
              <th>Date</th>
              <th>Action</th>
            </tr>

          </thead>

          <tbody>

            {contacts.map((contact) => (

              <tr key={contact.id}>

                <td>
                  <span className="contacts-id">
                    #{contact.id}
                  </span>
                </td>

                <td>
                  <div className="contacts-name">
                    {contact.fullName}
                  </div>
                </td>

                <td>{contact.email}</td>

                <td>{contact.phone}</td>

                <td>
                  <div className="contacts-enquiry">
                    {contact.enquiry}
                  </div>
                </td>

                <td>
                  {new Date(
                    contact.createdAt
                  ).toLocaleDateString()}
                </td>

                <td>

                  <button
                    className="contacts-view-btn"
                    onClick={() =>
                      setSelectedContact(contact)
                    }
                  >

                    <Eye size={16} />

                    View

                  </button>

                </td>

              </tr>
            ))}

          </tbody>

        </table>

      </div>

      {/* MODAL */}
      {selectedContact && (

        <div className="contacts-modal-overlay">

          <div className="contacts-modal">

            {/* HEADER */}
            <div className="contacts-modal-header">

              <div>

                <h2>
                  Contact #{selectedContact.id}
                </h2>

                <p>

                  Submitted on{" "}

                  {new Date(
                    selectedContact.createdAt
                  ).toLocaleDateString()}

                </p>

              </div>

              <button
                className="contacts-close-btn"
                onClick={() =>
                  setSelectedContact(null)
                }
              >

                <X size={26} />

              </button>

            </div>

            {/* BODY */}
            <div className="contacts-modal-body">

              {/* CONTACT DETAILS */}
              <div className="contacts-section">

                <h3>Contact Details</h3>

                <div className="contacts-details-grid">

                  <div className="contacts-detail-card">

                    <User size={18} />

                    <div>
                      <span>Full Name</span>
                      <p>
                        {selectedContact.fullName}
                      </p>
                    </div>

                  </div>

                  <div className="contacts-detail-card">

                    <Mail size={18} />

                    <div>
                      <span>Email</span>
                      <p>
                        {selectedContact.email}
                      </p>
                    </div>

                  </div>

                  <div className="contacts-detail-card">

                    <Phone size={18} />

                    <div>
                      <span>Phone</span>
                      <p>
                        {selectedContact.phone}
                      </p>
                    </div>

                  </div>

                  <div className="contacts-detail-card">

                    <BadgeHelp size={18} />

                    <div>
                      <span>Enquiry</span>
                      <p>
                        {selectedContact.enquiry}
                      </p>
                    </div>

                  </div>

                  <div className="contacts-detail-card">

                    <MessageSquareText size={18} />

                    <div>
                      <span>Message</span>
                      <p>
                        {selectedContact.message}
                      </p>
                    </div>

                  </div>

                  <div className="contacts-detail-card">

                    <Calendar size={18} />

                    <div>
                      <span>Submitted At</span>
                      <p>

                        {new Date(
                          selectedContact.createdAt
                        ).toLocaleString()}

                      </p>
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contacts;